import SagaDuck from '@duckness/saga'
import { take, throttle, call, put, type CallEffect, type PutEffect } from 'redux-saga/effects'
import { defaultEditor } from '@aytm/app/insights/dashboard/lib/config'

import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

import fetchAccessKeySaga from './sagas/fetchAccessKey.saga.ts'
import { ACCESS_KEY_ACTIONS, type AccessKeyActionsType } from './AccessKeyDuck.actions'
import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getAllFiltersMask } from '@aytm/app/insights/dashboard/lib/filters'
import type { AccessKeyDuckSelectorsType } from './AccessKeyDuck.types'
import { duckName } from '@aytm/app/insights/dashboard/duckness/ducks/AccessKeyDuck/constants'
import { DataDuck, DATA_ACTIONS } from '../DataDuck'
import type { AccessKeyType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

const AccessKeyDuck = SagaDuck<InsightsDashboardPoolState, AccessKeyActionsType, AccessKeyDuckSelectorsType>(
  duckName,
  'insights-dashboard'
)

const ACCESS_KEY_DEBOUNCE_TIMEOUT = 5000

// actions
AccessKeyDuck.action(ACCESS_KEY_ACTIONS.FETCH_ACCESS_KEY)
AccessKeyDuck.action(ACCESS_KEY_ACTIONS.UPDATE_ACCESS_KEY)

// selectors
AccessKeyDuck.selector('accessKey', state => state.accessKey)
AccessKeyDuck.selector('roles', state => state.accessKey?.roles || [])

// reducers
// AccessKeyDuck.reducer(
//   ACCESS_KEY_ACTIONS.FETCH_ACCESS_KEY,
//   state => state
// )

type UpdateAccessKeyPayloadType = {
  key: AccessKeyType
}

AccessKeyDuck.reducer<UpdateAccessKeyPayloadType>(ACCESS_KEY_ACTIONS.UPDATE_ACCESS_KEY, (state, action) => {
  const { key } = action.payload
  const roles = key?.roles || []
  const isEditorMode = roles.includes('editor')
  const isViewerMode = !roles.includes('editor')
  const resultState = {
    ...state,
    accessKey: key,
    isEditorMode,
    isViewerMode,
    editor: isEditorMode && !state?.isSharedView ? defaultEditor : null
  }
  resultState.allFiltersMask = getAllFiltersMask(resultState) as string[]
  return resultState
})
import { safelyExecuteSaga } from '@aytm/app/insights/dashboard/lib/safety'
import { ERROR_ACTIONS, ErrorDuck } from '@aytm/app/insights/dashboard/duckness/InsightsDashboardPool'

/**
 * Saga to fetch access key
 */
AccessKeyDuck.saga(function* fetchAccessKey(duckFace) {
  yield throttle<{ type: string; payload: { sharedKey: string } }>(
    ACCESS_KEY_DEBOUNCE_TIMEOUT,
    [duckFace.action[ACCESS_KEY_ACTIONS.FETCH_ACCESS_KEY].actionType],
    function* onFetchAccessKey(
      action
    ): Generator<CallEffect<unknown[] | Error[]> | PutEffect, void, [Error] | [null, AccessKeyType]> {
      const { sharedKey } = action.payload
      const [error, key] = yield call(safelyExecuteSaga, fetchAccessKeySaga, { sharedKey })
      if (error || !key) {
        yield put(
          ErrorDuck.action[ERROR_ACTIONS.SET_ERROR]({ type: 'key', error: error?.message || 'No auth key error' })
        )
        return
      }
      yield put(duckFace.action[ACCESS_KEY_ACTIONS.UPDATE_ACCESS_KEY]({ key }))
      yield put(DataDuck.action[DATA_ACTIONS.ALLOW_REQUEST_SCHEMA]()) // re-init other ducks
    }
  )
})

// fetch access key on INIT
AccessKeyDuck.saga(function* init(duckFace) {
  yield take(duckFace.mapActionType('@@INIT'))
  yield put(duckFace.action.fetchAccessKey({ sharedKey: staticStore.currentSharedKey }))
})

export default AccessKeyDuck
